class CardItemGoogleMaps {
  constructor($main) {
    console.log('CardItemGoogleMaps');
    this.initDomElements($main);
    this.domElements.previewImage.on('click', () => {
      this.showMap();
    });
    this.domElements.advice.on('click', event => {
      if (event.target.nodeName === 'A') return;
      this.showMap();
    });
  }

  initDomElements($main) {
    this.domElements = {};
    this.domElements.main = $main;
    if (this.domElements.main.length < 1) return false;
    this.domElements.previewImage = this.domElements.main.find('.card__item__maps__image');
    this.domElements.advice = this.domElements.main.find('.card__item__maps__privacy-advice');
    this.domElements.iframeCode = this.domElements.main.find('.card__item__maps__iframe-container');
    return true;
  }

  showMap() {
    console.log('showMap');
    const configuration = {};
    const contentEncoded = this.domElements.iframeCode.text();
    this.domElements.iframeCode.html(contentEncoded);
    this.domElements.iframeCode.show();
    this.domElements.previewImage.hide();
    this.domElements.advice.hide();
  }
}

export default CardItemGoogleMaps;
